/// REFERENCES:
//      id gen: https://stackoverflow.com/questions/49146325/get-firestore-generated-doc-id-after-set/49146671#49146671
//      array union: https://stackoverflow.com/questions/58186235/fieldvalue-is-undefined
//      variable key: https://stackoverflow.com/questions/11508463/javascript-set-object-key-by-variable
//      uploading files: https://firebase.google.com/docs/storage/web/upload-files
//      multiple dispatch: https://stackoverflow.com/questions/44321676/where-to-dispatch-multiple-actions-in-redux

import { storage, cloudFunction } from '../../config/firebaseConfig';
import firebase from "firebase/app";
import functions from "firebase/functions";
import { Document } from 'react-pdf';
import { getFirebase } from 'react-redux-firebase';
import { setOptions } from 'leaflet';
import { merge } from 'jquery';

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 1 => HANDLE CURRENT PROJECT DATA
///
export const setCurrentProjectId = (proid) => {
    return async (dispatch, getState, { getFirestore }) => {
        return dispatch({ type: "SET_CURRENT_PROJECT_ID", proid });
    }
    // return {
    //     type: "SET_CURRENT_PROJECT_ID",
    //     proid,
    // }
}

export const setCurrentSnagDetail = (snagDetail) => {
    return {
        type: "SET_CURRENT_SNAG_DETAIL",
        snagDetail,
    }
}

export const setCurrentFloorMeta = (floorMeta) => {
    return {
        type: "SET_CURRENT_FLOOR_META",
        floorMeta,
    }
}

export const setCurrentSnagDetailWithFloorMeta = (snagDetail, floorMeta) => {
    return {
        type: "SET_CURRENT_SNAG_DETAIL_WITH_FLOOR_META",
        snagDetail,
        floorMeta,
    }
}

export const clearProjectId = () => {
    return {
        type: "CLEAR_PROJECT_ID",
    }
}

export const openNewReportModal = () => {
    return {
        type: "OPEN_NEW_REPORT_MODAL",
    }
}

export const openManageProjectMemberModal = () => {
    return {
        type: "OPEN_NEW_MANAGE_PROJECT_MEMBER_MODAL",
    }
}

export const openCompanyMemberModal = () => {
    return {
        type: "OPEN_NEW_COMPANY_MEMBER_MODAL",
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 2 => NEW PROJECT CREATION AND UPDATES
///
export const openNewProjectPage = () => {
    return {
        type: "OPEN_NEW_PROJECT_PAGE",
    }
}

export const createProject = (userData, companyData, projectData, selectedFiles, tagCategory, isFloorsCreate) => {
    return async (dispatch, getState, { getFirestore }) => {
        /// dispatch to indicate project creation started
        dispatch({ type: "ADD_NEW_PROJECT" });

        // async call to upload new shape
        const firestore = getFirestore();

        // generate id
        const newProid = `webproj_${companyData.coid}_` + firestore.collection('Projects').doc().id;

        // testing id
        // const newProid = "webproj_testing";

        const ueid = `${userData.uid}${userData.employeeid}`;
        // upload files in loop and add non null files to list (to be added to project document)
        var uploadedFilesUrl = [];
        var uploadedFilesName = [];
        for (var i = 0; i < selectedFiles.length; ++i) {
            var result = await addPdfFile(newProid, selectedFiles[i]);
            if (result != null) {
                console.log(`Available at: ${result.substring(0, 5)}`);
                var uploadedFileName = await selectedFiles[i].name.replaceAll(/[/\-.\s]/g, '').toLowerCase();
                uploadedFilesUrl = [...uploadedFilesUrl, result];
                uploadedFilesName = [...uploadedFilesName, uploadedFileName.substring(0, uploadedFileName.length - 'pdf'.length)];
            }
        }

        /// dispatch to indicate successful file uploaded
        dispatch({ type: "FILES_ADDED" });

        // generate id
        let tagCategoryFilter = tagCategory.replace(/^[, ]+|[, ]+$|[, ]+/g, " ").trim();
        let tagCategoryList = tagCategoryFilter.split(' ');
        let allTagsMap = {};

        tagCategoryList.forEach((eachCategory, index) => {

            const newTagId = 'webtag_' + firestore.collection('Projects').doc().id;
            const tagObject = {
                [newTagId]: {
                    name: eachCategory,
                    tagid: newTagId,
                }
            }
            allTagsMap = { ...allTagsMap, ...tagObject };


        });

        const defaultTagId = 'webtag_' + firestore.collection('Projects').doc().id;
        const defaultTagsMap = {
            elevation: {
                name: 'elevation',
                tagid: 'elevation',
            },
            [defaultTagId]: {
                name: 'Unclassified',
                tagid: defaultTagId,
            },
        };

        allTagsMap = { ...allTagsMap, ...defaultTagsMap };


        // create new project document
        await firestore.collection('Projects').doc(newProid).set({
            showFreshIntroMob: true,
            showFreshIntroWeb: true,
            profilePic: companyData.profilePic ?? "",
            proid: `${newProid}`,
            projectTitle: `${projectData.projectTitle}` ?? "",
            projectTitleLC: `${projectData.projectTitle}`.toLowerCase() ?? "",
            companyName: `${companyData.companyName}` ?? "",
            creatorUid: `${userData.uid}` ?? "",
            creatorEmployeeid: `${userData.employeeid}` ?? "",
            coid: `${companyData.coid}` ?? "",
            accessList: firestore.FieldValue.arrayUnion(`${ueid}`),
            accessMap: {
                [ueid]: {
                    access: 0,
                    name: `${userData.name}` ?? "",
                    uid: `${userData.uid}` ?? "",
                    employeeid: `${userData.employeeid}` ?? "",
                    hasAllTags: true,
                    selectedTagsIdList: [],
                }

            },
            allTagsMap: allTagsMap,
            floorsMap: {},
            files: [...uploadedFilesUrl].length <= 0 ? [] : firestore.FieldValue.arrayUnion(...uploadedFilesUrl),
            email: `${projectData.email}` ?? "",
            phone: `${projectData.phone}` ?? "",
            dateCreated: firestore.FieldValue.serverTimestamp(),
            imageFilesList: [...uploadedFilesName].length <= 0 ? [] : firestore.FieldValue.arrayUnion(...uploadedFilesName),
            imageFilesCount: firestore.FieldValue.increment(uploadedFilesName.length),

            markerCount: {},
            floorsAndElevations: [],
            reportHasSynced: {},
            totalActiveExternalMember: 0,
            totalActiveInternalMember: 1,
            projectTagCount: 0
        });


        if (!isFloorsCreate) {
            const newFloorid = firestore.collection(`Projects/${newProid}/Markers`).doc().id;

            // update floorsMap with new floor
            await firestore.collection('Projects').doc(newProid).update({
                [`floorsMap.${newFloorid}`]: {
                    floorid: newFloorid,
                    name: "List of issues",
                    dateCreated: firestore.FieldValue.serverTimestamp(),
                    fileName: "",
                    proid: newProid,
                    containsMap: false,
                },
            });
        }


        // add project to company briefings
        await firestore.collection(`Companies/${companyData.coid}/Briefings`)
            .doc("projects").update({
                [`all.${newProid}`]: {
                    projectTitle: `${projectData.projectTitle}` ?? "",
                    proid: `${newProid}`,
                },
            });

        /// finally dispatch success action
        return dispatch({
            type: "NEW_PROJECT_ADDED",
            proid: newProid,
        });
    };
}

export const openUploadFilesModal = () => {
    return {
        type: "OPEN_UPLOAD_FILES_MODAL",
    }
}

export const deleteProject = (proid, coid) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {
        // README: getState should be initaialize to work getFirestore or getFirebase..
        dispatch({ type: "PROJECT_DELETION_START" });
        console.log(proid, coid)
        const firestore = getFirestore();
        const firebase = getFirebase();
        await firestore.collection('Projects').doc(proid).delete();
        await firestore.collection('Companies').doc(coid).collection('Briefings').doc('projects').set({
            'all': {
                [proid]: firebase.firestore.FieldValue.delete(),

            },
        },
            { merge: true }
        );
        return dispatch({
            type: "PROJECT_DELETED",
        });
    };
}

export const openDeleteProjectModal = () => {
    return {
        type: "OPEN_DELETE_PROJECT_MODAL",
    }
}

export const uploadMoreFilesInProject = (proid, selectedFiles) => {
    return async (dispatch, getState, { getFirestore }) => {
        /// dispatch to indicate project creation started
        dispatch({ type: "ADD_MORE_FILES" });

        // async call to upload new shape
        const firestore = getFirestore();

        // upload files in loop and add non null files to list (to be added to project document)
        var uploadedFilesUrl = [];
        var uploadedFilesName = [];
        for (var i = 0; i < selectedFiles.length; ++i) {
            var result = await addPdfFile(proid, selectedFiles[i]);
            if (result != null) {
                console.log(`Available at: ${result.substring(0, 5)}`);
                var uploadedFileName = await selectedFiles[i].name.replaceAll(/[/\-.\s]/g, '').toLowerCase();
                uploadedFilesUrl = [...uploadedFilesUrl, result];
                uploadedFilesName = [...uploadedFilesName, uploadedFileName.substring(0, uploadedFileName.length - 'pdf'.length)];
            }
        }

        /// dispatch to indicate successful file uploaded
        dispatch({ type: "MORE_FILES_ADDED" });

        // create new project document
        await firestore.collection('Projects').doc(proid).update({
            files: [...uploadedFilesUrl].length <= 0 ? [] : firestore.FieldValue.arrayUnion(...uploadedFilesUrl),
            imageFilesList: [...uploadedFilesName].length <= 0 ? [] : firestore.FieldValue.arrayUnion(...uploadedFilesName),
            imageFilesCount: firestore.FieldValue.increment(uploadedFilesName.length),
        });

        /// finally dispatch success action
        return dispatch({
            type: "MORE_FILES_UPLOADED",
        });
    };
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 2 => UPDATE PROJECT DETAIL
/// 
export const openProjectUpdateModal = () => {
    return {
        type: "OPEN_PROJECT_UPDATE_MODAL",
    }
}

export const updateProject = (proid, phone, email) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {
        /// dispatch to indicate project profile update started
        dispatch({ type: "UPDATE_PROJECT" });

        // async call to update the project profile to firebase
        const firestore = getFirestore();

        await firestore.collection('Projects').doc(proid).update({
            phone: `${phone}` ?? "",
            email: `${email}` ?? "",
        });

        /// finally dispatch success action
        return dispatch({
            type: "PROJECT_UPDATED",
        });

    }
};

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 3 => ADD FILES UTILS
/// 
async function addPdfFile(proid, selectedFile) {
    var selectedFileName = selectedFile.name.replaceAll(/[/\-.\s]/g, '').toLowerCase();
    selectedFileName = selectedFileName.substring(0, selectedFileName.length - 'pdf'.length) + '.pdf';
    console.log(`Uploading: ${selectedFileName}`);
    var metadata = {
        contentType: 'application/pdf',
        customMetadata: {
            isProjectFile: "1",
            collectionRef: "Projects",
            docRef: `${proid}`
        }
    };

    var storageReference = storage.ref(`Projects/${proid}/files/${selectedFileName}`);
    var uploadTask = await storageReference.put(selectedFile, metadata);
    return storageReference.getDownloadURL().then((downloadURL) => {
        return downloadURL;
    }).catch((err) => {
        console.error(err);
        return null;
    });
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 4 => ADD, DELETE, UPDATE TAGS
///
export const openNewTagModal = () => {
    return {
        type: "OPEN_NEW_TAG_MODAL",
    }
}

export const createTag = (proid, tagName) => {
    return async (dispatch, getState, { getFirestore }) => {
        /// dispatch to indicate tag creation started
        dispatch({ type: "ADD_NEW_TAG" });

        // async call to upload new shape
        const firestore = getFirestore();

        // generate id
        const newTagid = 'webtag_' + firestore.collection('Projects').doc().id;

        // update project allTagsMap with this tag
        await firestore.collection('Projects').doc(proid).update({
            [`allTagsMap.${newTagid}`]: {
                tagid: newTagid,
                name: `${tagName}` ?? "",
            },
        });

        /// finally dispatch success action
        return dispatch({
            type: "NEW_TAG_ADDED",
        });
    };
}

export const updateTag = (proid, tagMap) => {
    return async (dispatch, getState, { getFirestore }) => {
        /// dispatch to indicate tag creation started
        dispatch({ type: "UPDATE_TAG" });

        // async call to upload new shape
        const firestore = getFirestore();

        // get tag name and id
        var name = tagMap.tagName;
        var tagid = tagMap.tagid;
        console.log(tagMap);

        // update project allTagsMap with this tag
        await firestore.collection('Projects').doc(proid).update({
            [`allTagsMap.${tagid}`]: {
                tagid: tagid,
                name: `${name}` ?? "",
            },
        });

        /// finally dispatch success action
        return dispatch({
            type: "TAG_UPDATED",
        });
    };
}

export const deleteTag = (proid, tagid, tagName) => {
    return async (dispatch, getState, { getFirestore }) => {
        /// dispatch to indicate tag creation started
        dispatch({ type: "DELETE_TAG" });

        // async call to upload new shape
        const firestore = getFirestore();

        // update project allTagsMap with this tag
        await firestore.collection('Projects').doc(proid).update({
            [`allTagsMap.${tagid}.name`]: `${tagName} [DELETED]`,
        });

        /// finally dispatch success action
        return dispatch({
            type: "TAG_DELETED",
        });
    };
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 5 => API CALLS FOR PROJECT MANAGEMENT
/// 

// 0
export const sendProjectRequest = (requestMakerJson, projectModelJson) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "PAPI_CALL_INIT",
            papiMessage: "Please wait while we are processing...",
            showPapiLoader: true,
            papid: 0,
        });

        cloudFunction.httpsCallable('project-includeIntoProjectRequest')(
            {
                requestMakerJson,
                projectModelJson
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "PAPI_CALL_COMPLETED",
                    papiMessage: res.data.responseMsg,
                    showPapiLoader: false,
                    papid: -1,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "PAPI_CALL_ERROR",
                    papiMessage: error,
                    showPapiLoader: false,
                    papid: -1,
                });
            });
    }
}

// 1
export const removeMemberFromProject = (toBeRemovedUserJson, projectModelJson) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "PAPI_CALL_INIT",
            papiMessage: "Please wait while we are processing...",
            showPapiLoader: true,
            papid: 1,
        });

        cloudFunction.httpsCallable('project-getRemovedFromProject')(
            {
                toBeRemovedUserJson,
                projectModelJson
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "PAPI_CALL_COMPLETED",
                    papiMessage: res.data.responseMsg,
                    showPapiLoader: false,
                    papid: -1,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "PAPI_CALL_ERROR",
                    papiMessage: error,
                    showPapiLoader: false,
                    papid: -1,
                });
            });
    }
}

// 2
export const changeMemberRoleProject = (changerEmployeeMapJson, toBeChangedEmployeeMapJson, projectModelJson, newAccessLevel) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "PAPI_CALL_INIT",
            papiMessage: "Please wait while we are processing...",
            showPapiLoader: true,
            papid: 2,
        });

        cloudFunction.httpsCallable('project-updateMemberRoleInProject')(
            {
                changerEmployeeMapJson,
                toBeChangedEmployeeMapJson,
                projectModelJson,
                newAccessLevel
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "PAPI_CALL_COMPLETED",
                    papiMessage: res.data.responseMsg,
                    showPapiLoader: false,
                    papid: -1,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "PAPI_CALL_ERROR",
                    papiMessage: error,
                    showPapiLoader: false,
                    papid: -1,
                });
            });
    }
}

// 3
export const addMemberToProject = (changerEmployeeMapJson, toBeGivenAccessEmployeeMapJson, selectedLevel, projectModelJson) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "PAPI_CALL_INIT",
            papiMessage: "Please wait while we are processing...",
            showPapiLoader: true,
            papid: 3,
        });

        cloudFunction.httpsCallable('project-addMemberToProject')(
            {
                changerEmployeeMapJson,
                toBeGivenAccessEmployeeMapJson,
                selectedLevel,
                projectModelJson
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "PAPI_CALL_COMPLETED",
                    papiMessage: res.data.responseMsg,
                    showPapiLoader: false,
                    papid: -1,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "PAPI_CALL_ERROR",
                    papiMessage: error,
                    showPapiLoader: false,
                    papid: -1,
                });
            });
    }
}

// 4
export const changeMemberTagsInProject = (changerEmployeeMapJson, toBeChangedEmployeeJson, projectModelJson, hasAllTags, selectedTagsIdList) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "PAPI_CALL_INIT",
            papiMessage: "Please wait while we are processing...",
            showPapiLoader: true,
            papid: 4,
        });

        cloudFunction.httpsCallable('project-changeEmployeeTagsInProject')(
            {
                changerEmployeeMapJson,
                toBeChangedEmployeeJson,
                projectModelJson,
                hasAllTags,
                selectedTagsIdList
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "PAPI_CALL_COMPLETED",
                    papiMessage: res.data.responseMsg,
                    showPapiLoader: false,
                    papid: -1,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "PAPI_CALL_ERROR",
                    papiMessage: error,
                    showPapiLoader: false,
                    papid: -1,
                });
            });
    }
}

// 5
export const includeIntoProjectAccept = (acceptorJson, requestMakerJson, projectModelJson, hasAllTags, selectedTagsIdList, selectedLevel) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "PAPI_CALL_INIT",
            papiMessage: "Please wait while we are processing...",
            showPapiLoader: true,
            papid: 5,
        });

        cloudFunction.httpsCallable('project-includeIntoProjectAccept')(
            {
                acceptorJson,
                requestMakerJson,
                projectModelJson,
                hasAllTags,
                selectedTagsIdList,
                selectedLevel
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "PAPI_CALL_COMPLETED",
                    papiMessage: res.data.responseMsg,
                    showPapiLoader: false,
                    papid: -1,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "PAPI_CALL_ERROR",
                    papiMessage: error,
                    showPapiLoader: false,
                    papid: -1,
                });
            });
    }
}

// 6
export const compileProjectReportByCall = (userModelJson, specificTagList, projectModelJson) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "PAPI_CALL_INIT",
            papiMessage: "Please wait while we are processing...",
            showPapiLoader: true,
            papid: 6,
        });

        cloudFunction.httpsCallable('reporting-compileProjectReportByCall')(
            {
                userModelJson,
                specificTagList,
                projectModelJson,

            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "PAPI_CALL_COMPLETED",
                    papiMessage: res.data.responseMsg,
                    showPapiLoader: false,
                    papid: -1,
                    papiIsDoneAndSent: res.data.isDoneAndSent,
                });
            })
            .then(() => {
                // Create a reference to the file we want to download
                var reportRef = storage.ref(`/Projects/${projectModelJson.proid}/reports/-report.pdf`);

                // Get the download URL
                reportRef.getDownloadURL().then(url => {
                    console.log(url, "url")
                    var win = window.open(url, '_blank');
                    win.focus();
                }).catch((error) => {
                    /// dispatch to indicate unsuccessful request
                    dispatch({
                        type: "PAPI_CALL_ERROR",
                        papiMessage: error,
                        showPapiLoader: false,
                        papid: -1,
                    });
                })
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "PAPI_CALL_ERROR",
                    papiMessage: error,
                    showPapiLoader: false,
                    papid: -1,
                });
            });
    }
}

// 7
export const postReportRequestGenByCall = (userModelJson, specificTagList, projectModelJson) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "PAPI_CALL_INIT",
            papiMessage: "Please wait while we are processing...",
            showPapiLoader: true,
            papid: 7,
        });

        cloudFunction.httpsCallable('reportNotifier-postReportRequestGenByCall')(
            {
                userModelJson,
                specificTagList,
                projectModelJson,

            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "PAPI_CALL_COMPLETED",
                    papiMessage: res.data.responseMsg,
                    showPapiLoader: false,
                    papid: -1,
                    papiIsDoneAndSent: res.data.isDoneAndSent,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "PAPI_CALL_ERROR",
                    papiMessage: error,
                    showPapiLoader: false,
                    papid: -1,
                });
            });
    }
}